import Layout from '../../components/Layout';

export default function Settings() {
    return (
        <Layout>
            <div className="space-y-8">
                <div>
                    <h1 className="text-3xl font-bold text-gray-900">Cài đặt</h1>
                    <p className="mt-1 text-gray-500">Cấu hình hệ thống và không gian làm việc của cửa hàng.</p>
                </div>

                <section className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
                    <h2 className="text-lg font-semibold text-gray-900">Thông tin không gian làm việc</h2>
                    <p className="mt-2 max-w-3xl text-sm leading-6 text-gray-600">
                        Quản lý và cấu hình thông tin cửa hàng, múi giờ và các thiết lập cơ bản cho tài khoản của bạn.
                    </p>
                </section>
            </div>
        </Layout>
    );
}
